<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <h3 class="mb-0">Listado de notificaciones</h3>
            </b-card-header>

            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      :data="tableData">
              <el-table-column label="DESTINO"
                               min-width="170px"
                               prop="type">
              </el-table-column>
              <el-table-column label="TITULO"
                               prop="title"
                               min-width="300px">
              </el-table-column>

              <el-table-column label="MENSAJE"
                               min-width="200px"
                               prop="message">
              </el-table-column>
              <el-table-column label="ICONO"
                               min-width="200px"
                               prop="icon">
              </el-table-column>
              <el-table-column label="DEFAULT"
                               min-width="200px"
                               prop="DEFAULT">
                <template v-slot="{row}">
                  <b-checkbox v-model="row.default" :disabled="row.default" @change="makeDefaul(row)"></b-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Fecha registro" prop="created_at" min-width="200px">
                <template v-slot="{row}">
                  {{ row.created_at|formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="Opciones" min-width="200px">
                <template v-slot="{row}">
                  <button class="btn btn-sm btn-outline-primary" @click="deleteNotification(row._id)">
                    <i class="ni ni-fat-remove"></i>
                  </button>
                </template>
              </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
              <base-pagination v-model="currentPage" :per-page="20" :total="total"></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui'
import {get, post} from "@/util/axiosRequest";

export default {
  name: 'page-visits-table',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    tableData: [
      {
        bank: '',
        title: '',
        message: '',
        icon: '',
        status: '',
        created_at: ''
      },
    ],
    currentPage: 1,
    total: 0
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      get('notifications/find-all', null, true).then(({data}) => {
        this.tableData = data
        this.total = data.length
      })
    },
    remove(id) {
      post("notifications/remove", {_id: id}, true).then(() => {
        this.getData()
        this.showMessage("Notificacion desactivada correctamente")
      })
    },
    deleteNotification(id) {
      post("notifications/delete", {_id: id}, true).then(() => {
        this.getData()
        this.showMessage("Notificacion borrada correctamente")
      })
    },
    makeDefaul(row){
      post(`notifications/make-default`, {_id: row._id, type: row.type}, true)
      .then(() => this.getData())
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
  }
}
</script>
<style>
</style>

